import { useState, useEffect } from "react";
import API from "@/lib/api";
import { Eye, ArrowRight, Loader2 } from "lucide-react";

const BAND_DESCRIPTIONS = [
  "Master all 100 addition facts (0+0 through 9+9) with 5-second fluency",
  "Master all 100 subtraction facts (0\u22120 through 18\u22129) with 5-second fluency",
  "Master all 144 multiplication facts (1\u00d71 through 12\u00d712) with 5-second fluency",
  "Master all 144 division facts (1\u00f71 through 144\u00f712) with 5-second fluency",
];

export default function SkillPreview({ bandId, onReady }) {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    API.get(`/skill-bands/preview/${bandId}`)
      .then(({ data }) => setPreview(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [bandId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <Loader2 className="w-6 h-6 text-cyber animate-spin" />
      </div>
    );
  }

  if (!preview) return null;

  return (
    <div className="w-full max-w-lg mx-auto animate-slide-up" data-testid="skill-preview">
      <div className="glass-surface rounded-xl p-8">
        <div className="flex items-center gap-2 mb-2">
          <Eye className="w-5 h-5 text-cyber" />
          <span className="font-mono text-xs text-cyber uppercase tracking-wider">Level {bandId + 1}</span>
        </div>

        <h2 className="font-heading text-2xl font-bold text-white mb-2 tracking-tight">
          {preview.band.name}
        </h2>
        <p className="font-body text-sm text-white/50 mb-6">
          {BAND_DESCRIPTIONS[bandId] || "Practice this skill band"}
        </p>

        <div className="mb-6">
          <p className="font-mono text-xs text-white/30 uppercase tracking-wider mb-3">Sample Problems</p>
          <div className="space-y-2">
            {preview.samples.map((s, i) => (
              <div
                key={i}
                data-testid={`preview-sample-${i}`}
                className="flex items-center justify-between p-3 rounded-lg bg-white/[0.03] border border-white/5"
              >
                <span className="font-mono text-lg text-white">{s.text} = ?</span>
                <span className="font-mono text-sm text-white/20">{s.answer}</span>
              </div>
            ))}
          </div>
        </div>

        <p className="font-body text-xs text-white/30 mb-4 text-center">
          Timer: {preview.band.timer} seconds per problem
        </p>

        <button
          onClick={onReady}
          data-testid="preview-ready-btn"
          className="w-full btn-cyber py-3 rounded-full font-heading text-sm tracking-wider flex items-center justify-center gap-2"
        >
          I'M READY <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
